import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const AddVillaRequestSheme = Yup.object().shape({
  name: Yup.string().required(),
  surname: Yup.string().required(),
  phoneNumberIsValid: Yup.boolean().isTrue(),
  email: Yup.string().required().email(),
  destination: Yup.string().required(),
  roomCount: Yup.string().required(),
  poolType: Yup.array().min(1).required(),
  seaView: Yup.string().required(),
  message: Yup.string(),
});
